import React from 'react';
import styles from './index.module.scss';

function Layout (props: Record<string, any>) {
  const { children } = props;

  return (
    <div className={styles.layout}>
      {children}
    </div>
  );
};

export default Layout;
